// extracted by mini-css-extract-plugin
export var navbarSubLink = "C_f6 d_f6 d_f0 d_X d_b8 d_dj d_bp d_bQ";
export var menuLink = "C_tj d_fX d_dx";
export var subPageLink = "C_gb d_gb d_dn d_dr";
export var subPageLinkColor = "C_gc d_gc";
export var burgerItemSmall = "C_tk d_f9 d_W d_bq";
export var Link = "C_r0 s_r0 s_rk s_rF";